import React from "react";
import styled from "styled-components";
import logo from "assets/images/blue_logo.png";

export interface OmronHeaderProps {
  link: { label: string; path: string };
  label: string[];
  user?: string;
}

const OmronHeader: React.FC<OmronHeaderProps> = (props: OmronHeaderProps) => {
  const { link, label, user } = props;
  return (
    <>
      <Header>
        <ServiceNameWrap>
          <LogoImage src={logo} alt="omron" />
          <ServiceName>License portal</ServiceName>
        </ServiceNameWrap>
        {user && (
          <LoginUser>
            <LoginUserId>ID&nbsp;:&nbsp;{user}</LoginUserId>
          </LoginUser>
        )}
      </Header>
      <BreadcrumbNav>
        <BreadcrumbDiv>
          <BreadcrumbLink href={link.path}>{link.label}</BreadcrumbLink>
          {label.map((x) => (
            <React.Fragment key={x}>
              <BreadcrumbArrow key={`arrow_${x}`}>&gt;</BreadcrumbArrow>
              <BreadcrumbLink2 key={`label_${x}`}>{x}</BreadcrumbLink2>
            </React.Fragment>
          ))}
        </BreadcrumbDiv>
      </BreadcrumbNav>
    </>
  );
};

export default OmronHeader;

OmronHeader.defaultProps = {
  user: undefined,
};

// style

const Header = styled.header`
  grid-area: header;
  position: sticky;
  top: 0;
  align-self: start;
  height: 76px;
  display: flex;
  justify-content: space-between;
  border-bottom: 0.1rem solid rgba(0, 0, 0, 0.1);
  background: #ffffff;
  z-index: 4;
`;

const ServiceName = styled.div`
  margin: 1.5rem 0;
  font-size: 1.71rem;
  line-height: 2rem;
  letter-spacing: 0.07rem;
  font-weight: normal;
`;
const LogoImage = styled.img`
  height: 100%;
`;
const ServiceNameWrap = styled.div`
  display: flex;
`;

const BreadcrumbNav = styled.nav`
  grid-area: breadc;
  position: sticky;
  top: 77px;
  align-self: start;
  background: #fafafa;
  z-index: 4;
`;

const BreadcrumbDiv = styled.div`
  padding: 0.8rem 2.1rem;
  font-size: 11px;
  line-height: 1.45;
  letter-spacing: 0.4px;
  font-weight: normal;
  color: #999999;
`;

const BreadcrumbLink = styled.a`
  display: inline-block;
  margin-right: 4px;
  color: #333333;
  text-decoration: none;
  :hover {
    color: #999999;
  }
`;
const BreadcrumbLink2 = styled.a`
  display: inline-block;
  margin-right: 4px;
  color: #999999;
  pointer-events: none;
  text-decoration: none;
`;

const BreadcrumbArrow = styled.span`
  display: inline-block;
  margin-right: 4px;
`;

const LoginUser = styled.div`
  margin: 1rem 2rem;
  border: 0.1rem solid rgba(0, 0, 0, 0.1);
`;

const LoginUserId = styled.p`
  padding: 0.7rem 1rem;
  font-size: 1.14rem;
  line-height: 1.57rem;
  letter-spacing: 0.06rem;
  font-weight: normal;
`;
